import { render, staticRenderFns } from "./NSingleSelect.vue?vue&type=template&id=489bf8cc&"
import script from "./NSingleSelect.vue?vue&type=script&lang=js&"
export * from "./NSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./NSingleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports